import React from 'react'

// Deps
import { redirect } from 'controllers/navigator'

// Sections
import AccountList from 'views/admin/sections/account-list'
import Breadcrumbs from 'views/admin/sections/breadcrumbs'

// Hooks
import useQuery from 'hooks/query'

const defaultQuery = {
	page: 1,
	sort_by: 'created_at',
	search_value: '',
}

const Accounts = (props) => {
	const rawQuery = props.match.params.query;

	const [query, urlQuery] = useQuery(rawQuery, defaultQuery);

	const search = (formData) => {
		let newQuery = [];

		for(const param in formData) {
			if(defaultQuery[param] !== formData[param]) {
				newQuery.push(param + '=' + formData[param]);
			}
		}

		redirect('settings.accounts', { query: newQuery.join('&') });
	}

	const paginate = (page) => {
		search({...urlQuery, page: page});
	}

	return (
		<main className="page accounts">
			<Breadcrumbs />
			<AccountList
				onSearch={search}
				onPaginate={paginate}
				query={query} />
		</main>
	)
}

export default Accounts